import { render, staticRenderFns } from "./TrainingCourses.vue?vue&type=template&id=28a55e20&scoped=true&"
import script from "./TrainingCourses.vue?vue&type=script&lang=js&"
export * from "./TrainingCourses.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCourses.vue?vue&type=style&index=0&id=28a55e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a55e20",
  null
  
)

export default component.exports